import theme from '../../theme/theme';

const {
  colors: { subtitle, black_text, white_text },
} = theme;

const styles = {
  list__container: {
    display: 'flex',
    padding: '1.5em 1em 1.5em 1em',
  },

  scroll__view: {
    height: '84vh',
    overflow: 'auto',
    position: 'relative',
    paddingBottom: '4em',
    flex: 1,
  },

  icons: {
    height: '2em',
  },

  title: {
    color: black_text,
    fontSize: '1.5em',
  },

  subtitle: {
    color: subtitle,
    fontSize: '1.125em',
    paddingRight: '1em',
  },

  price: {
    display: 'flex',
    padding: '.2em .8em .2em .8em',
    alignItems: 'center',
    borderRadius: '0.8em',
    backgroundColor: subtitle,
    color: white_text,
    fontSize: '1.125em',
  },

  footer: {
    position: 'absolute',
    bottom: 0,
    display: 'flex',
    width: '100%',
    height: '4.625em',
  },
};

export default styles;
